const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;
const API_URL = process.env.REACT_APP_API_URL;

export function generateCode() {
  return String(Math.floor(100000 + Math.random() * 900000));
}

export async function hashCode(code) {
  const encoder = new TextEncoder();
  const data = encoder.encode(code);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function storeOtp(email, code) {
  const hash = await hashCode(code);

  const expiresAt =
    new Date(
      Date.now() +
      30 * 60 * 1000
    ).toISOString();

  await fetch(
    `${SUPABASE_URL}/rest/v1/otp_codes?email=eq.${encodeURIComponent(email)}&used=eq.false`,
    {
      method: 'DELETE',
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': 'Bearer ' + SUPABASE_KEY
      }
    }
  );

  const response = await fetch(`${SUPABASE_URL}/rest/v1/otp_codes`, {
    method: 'POST',
    headers: {
      'apikey': SUPABASE_KEY,
      'Authorization': 'Bearer ' + SUPABASE_KEY,
      'Content-Type': 'application/json',
      'Prefer': 'return=representation'
    },
    body: JSON.stringify({ email, code_hash: hash, expires_at: expiresAt })
  });

  const result = await response.json();
  if (!response.ok) throw new Error('Failed to store verification code: ' + JSON.stringify(result));
}

export async function sendOtp(email, code) {
  await fetch(API_URL, {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify({ action: 'sendOtp', email, code }),
    headers: { 'Content-Type': 'application/json' }
  });
}

export async function verifyOtp(supabase, email, submittedCode) {
  const hash = await hashCode(submittedCode);

  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/otp_codes?email=eq.${encodeURIComponent(email)}&code_hash=eq.${hash}&used=eq.false&select=id,expires_at,used`,
    {
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': 'Bearer ' + SUPABASE_KEY,
        'Accept': 'application/vnd.pgrst.object+json'
      }
    }
  );

  const data = await response.json();
  if (!response.ok || !data) throw new Error('That code is invalid or has expired.');
  if (new Date(data.expires_at) < new Date()) throw new Error('That code has expired.');

  await fetch(
    `${SUPABASE_URL}/rest/v1/otp_codes?id=eq.${data.id}`,
    {
      method: 'PATCH',
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': 'Bearer ' + SUPABASE_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ used: true })
    }
  );

  return true;
}